import { create } from 'zustand';

import { IDataProducto, ProductosParam } from '@/shared/interfaces';
import { getProductos } from '@/shared/actions/erp/producto.action';

interface IProductoStore {
  productos: IDataProducto[];

  productosVentas: IDataProducto[],

  isLoadingProducto: boolean;

  getProducto: (params?: ProductosParam) => Promise<void>;
  getProductoVentas: (params?: ProductosParam) => Promise<void>;
}

export const useProductosStore = create<IProductoStore>(set => ({
  productos: [],
  productosVentas: [],

  isLoadingProducto: false,

  getProducto: async params => {
    set({ isLoadingProducto: true });
    const { data } = await getProductos(params);
    set({ productos: data.data });
    set({ isLoadingProducto: false });
  },

  getProductoVentas: async params => {
    set({ isLoadingProducto: true });
    const { data } = await getProductos(params);
    set({ productosVentas: data.data.filter(e => e.es_para_venta) });
    set({ isLoadingProducto: false });
  },
}));
